import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.687 4.049V.81L1.03 6.467l5.657 5.657V8.87c2.425-.36 4.971.375 6.838 2.242a7.912 7.912 0 0 1 1.944 3.189c.573-2.723-.183-5.671-2.298-7.785-1.782-1.782-4.158-2.588-6.484-2.468Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.685 13.128A7.911 7.911 0 0 1 .74 9.938a8.479 8.479 0 0 0 2.298 7.786 8.47 8.47 0 0 0 6.485 2.468l-.007 3.246 5.656-5.657-5.656-5.657v3.253c-2.419.353-4.964-.382-6.831-2.249Z"
})), 'ExchangeCircle', {
  viewBox: '0 0 16 24'
});